import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select, { OptionType } from 'src/components/Select';
import TextField from 'src/components/TextField';
import { ReturnType } from 'src/types/return';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import DateTimePicker from 'src/components/DateTimePicker';
import { orderTypeCodes } from 'src/resources/constantsCodes/constants';
import { OrderType } from 'src/types/order';
import Switch from 'src/components/Switch';
import Typography from 'src/components/Typography';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface OrderDetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ReturnType;
    editErrors: FormErrorsType;
    newReturn: boolean;
    disableEdit: boolean;
    shipperCodes: ConstantsCodeType[];
    serviceCodes: ConstantsCodeType[];
    createReturnFromList: boolean;
    permissionEditNote: boolean;
    ordersOptions: OptionType[];
    orderData: OrderType | null;
    isDcixReturn: boolean;
}

const OrderDetail: FC<OrderDetailPropsType> = (props) => {
    return (
        <Grid>
            {props.newReturn && (
                <GridItem cols={12}>
                    <Typography gutterBottom variant="h2">
                        {translate('returnDetail.orderTitle')}
                    </Typography>
                </GridItem>
            )}
            {!props.newReturn && (
                <GridItem cols={12}>
                    <TextField
                        value={props.editData.NOTE}
                        error={props.editErrors.NOTE}
                        onChange={(value, error) => props.onChange('NOTE', value, error)}
                        name="NOTE"
                        label={translate('returnDetail.note')}
                        fullWidth
                        multiline
                        disabled={(props.disableEdit && !props.permissionEditNote) || props.isDcixReturn}
                    />
                </GridItem>
            )}
            {!props.newReturn && (
                <GridItem cols={12}>
                    <TextField
                        value={props.editData.ESHOP_NOTE}
                        error={props.editErrors.ESHOP_NOTE}
                        onChange={(value, error) => props.onChange('ESHOP_NOTE', value, error)}
                        name="ESHOP_NOTE"
                        label={translate('returnDetail.eshopNote')}
                        fullWidth
                        multiline
                    />
                </GridItem>
            )}
            <GridItem cols={12}>
                {props.disableEdit || !props.createReturnFromList ? (
                    <TextField
                        value={props.editData.ORDER_ID}
                        error={props.editErrors.ORDER_ID}
                        onChange={(value, error) => props.onChange('ORDER_ID', value, error)}
                        name="ORDER_ID"
                        label={translate('returnDetail.orderId')}
                        fullWidth
                        disabled
                    />
                ) : (
                    <Select
                        options={props.ordersOptions}
                        value={props.editData.ORDER_ID}
                        error={props.editErrors.ORDER_ID}
                        onChange={(value, error) => props.onChange('ORDER_ID', value, error)}
                        name="ORDER_ID"
                        label={translate('returnDetail.orderId')}
                        virtualized
                        fullWidth
                    />
                )}
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.ESHOP_ORDER_ID ?? props.orderData?.ESHOP_ORDER_ID}
                    label={translate('returnDetail.order.eshopOrderId')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={orderTypeCodes}
                    value={props.editData.ORDER_TYPE}
                    error={props.editErrors.ORDER_TYPE}
                    onChange={(value, error) => props.onChange('ORDER_TYPE', value, error)}
                    name="ORDER_TYPE"
                    label={translate('returnDetail.orderType')}
                    fullWidth
                    disabled={props.disableEdit || !!props.editData.ORDER_ID}
                    required
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={
                        props.shipperCodes.find(
                            (o) =>
                                o.value ===
                                (props.editData.ORDER_SHIPPER ?? props.orderData?.SHIPPER)
                        )?.label ?? ''
                    }
                    label={translate('returnDetail.order.shipper')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={
                        props.serviceCodes.find(
                            (o) =>
                                o.shipperCode === (props.editData.ORDER_SHIPPER ?? props.orderData?.SHIPPER) &&
                                o.value ===
                                    (props.editData.ORDER_SHIPPER_SERVICE_CODE ?? props.orderData?.SHIPPER_SERVICE_CODE)
                        )?.label ?? ''
                    }
                    label={translate('returnDetail.order.shipperService')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.ORDER_TRACKING_NUMBER ?? props.orderData?.TRACKING_NUMBER}
                    label={translate('returnDetail.order.trackingNumber')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <DateTimePicker
                    type="dateTime"
                    value={props.editData.ORDER_DELIVERED_AT ?? props.orderData?.DELIVERED_AT}
                    label={translate('returnDetail.order.deliveredAt')}
                    fullWidth
                    disabled
                />
            </GridItem>
        </Grid>
    );
};

export default OrderDetail;
